export default "__VITE_ASSET__wWXSsBRm__"